import React from "react";
import Calendar from "../../components/calendar/calendar";

function CalendarRoute() {
  return <Calendar />;
}

export default CalendarRoute;
